import { render } from "./PracticesPaymentView.vue?vue&type=template&id=ec9f6eb6"
import script from "./PracticesPaymentView.vue?vue&type=script&lang=js"
export * from "./PracticesPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__